import React from 'react'
import ReactLoading from "react-loading";

const Loading = () => {
  return (
    <div>
       <ReactLoading type="spin" color="#2E8BFF"
              height={200} width={100} />
    </div>

  )
}

export default Loading